import { Route, Routes } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import LogIn from "./pages/LogIn";
import { BrowserRouter } from "react-router-dom";
import { RecoilRoot } from "recoil";
import RequireAuth from "@auth-kit/react-router/RequireAuth";

function App() {
  return (
    <>
      <RecoilRoot>
        <BrowserRouter basename="/">
          <Routes>
            <Route path="/login" element={<LogIn />} />
            <Route
              path="/*"
              element={
                <RequireAuth fallbackPath={"/login"}>
                  <Dashboard />
                </RequireAuth>
              }
            />
          </Routes>
        </BrowserRouter>
      </RecoilRoot>
    </>
  );
}

export default App;